import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const ClearOption = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='ClearOption' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M10,4 C10,2.8954305 10.8954305,2 12,2 C13.1045695,2 14,2.8954305 14,4 L14,10 L20,10 L20,14 L4,14 L4,10 L10,10 L10,4 Z M4,14 L20,14 L20,22 L12,22 L4,22 L4,14 Z M16,22 L16,16.3646005 M8,22 L8,16.3646005 M12,22 L12,16.3646005' />
  </StyledIcon>
);
